var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"portfoliogrid"}},[_c('AssetsChart',{attrs:{"id":"assetschart"}}),_c('ValueChart',{attrs:{"id":"valuechart"}}),_c('Assets',{attrs:{"id":"assets"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }